// semeia-disable-reexport
type KfreCoeff = {
  age: number;
  sex: number;
  dfg: number;
  rac: number;
};

type KfreArguments = {
  age: number;
  sex: "male" | "female";
  dfg: number;
  rac: number;
  years: 2 | 5;
};
const baseline5years = 0.924;

const coeff5years = {
  sex: 0.2694,
  age: -0.2167,
  dfg: -0.55418,
  rac: 0.45608
};

const xbar5years = {
  sex: 0.56422,
  age: 7.0355,
  dfg: 7.2216,
  rac: 5.2774
};

const baseline2years = 0.975;

const coeff2years = {
  sex: 0.2467,
  age: -0.2201,
  dfg: -0.5567,
  rac: 0.451
};

const xbar2years = {
  sex: 0.5642,
  age: 7.036,
  dfg: 7.222,
  rac: 5.137
};

export function computeKfreAsPercent(o: KfreArguments) {
  return (computeKfre(o) * 100).toFixed(2);
}

function sumObject(o): number {
  return Object.keys(o).reduce((acc, key) => acc + o[key], 0);
}

function getbetaXbar(coeff, xbar): KfreCoeff {
  const betaXbar = {
    sex: coeff.sex * xbar.sex,
    age: coeff.age * xbar.age,
    dfg: coeff.dfg * xbar.dfg,
    rac: coeff.rac * xbar.rac
  };
  return betaXbar;
}

function getbetaX(coeff, age, sex, dfg, rac): KfreCoeff {
  const betaX = {
    age: (age / 10) * coeff.age,
    sex: (sex == "male" ? 1 : 0) * coeff.sex,
    dfg: (dfg / 5) * coeff.dfg,
    rac: Math.log(rac) * coeff.rac
  };
  return betaX;
}

export function computeKfre({
  age,
  sex,
  dfg,
  rac,
  years
}: KfreArguments): number {
  const coeff = years === 2 ? coeff2years : coeff5years;
  const xbar = years === 2 ? xbar2years : xbar5years;
  const baseline = years === 2 ? baseline2years : baseline5years;

  const betaX = getbetaX(coeff, age, sex, dfg, rac);

  const betaXbarSum = sumObject(getbetaXbar(coeff, xbar));
  const betaXSum = sumObject(betaX);

  const risk = 1 - Math.pow(baseline, Math.exp(betaXSum - betaXbarSum));
  return risk;
}
